// A WAIT'S KEY, AND WHAT A VERDICT ON IT WAS MADE ON.
//
// Its own module, with nothing but node:crypto and the pure prompt module
// under it, so tools/seed-crm.ts can key the fixture's verdicts exactly as the
// triage and the pages do without opening the app's database.
//
// Erasable TypeScript (tools/ imports this under node's type stripping).

import { createHash } from "node:crypto";
import { triageInputText } from "@/lib/client-slack-prompts";
import type { Wait, WaitMessage } from "@/lib/client-slack-waits";

const sha = (s: string): string => createHash("sha256").update(s).digest("hex");

/**
 * A wait's id: its channel, its thread and its first message, hashed into one
 * opaque token that is safe in a URL (the inbox's `/brands/inbox/<wait>`) and
 * names nobody. Stable for as long as the wait's first message is not deleted;
 * a wait whose first message goes is a new wait.
 */
export function waitId(w: Pick<Wait, "channelId" | "threadTs" | "anchors">): string {
  return `w${sha(`${w.channelId}\u0000${w.threadTs}\u0000${w.anchors[0]}`).slice(0, 24)}`;
}

/** What a verdict is kept against: the prompt's version and the waiting messages' ts and words. */
export function waitInputHash(w: Pick<Wait, "anchors">, messages: readonly Pick<WaitMessage, "ts" | "text">[]): string {
  return sha(triageInputText(w, messages));
}
